import React from "react";
import { colourClasses } from "@/lib/colours";
import { SHIFT_STATUS_ORDER, SHIFT_STATUS_META, ASSET_STATE_META } from "@/lib/shiftStatus";

function Pill({ meta }) {
  const c = colourClasses(meta.colour);
  const Icon = meta.Icon;
  return (
    <div className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${c.bg} ${c.border} ${c.text}`}>
      <Icon className="w-3.5 h-3.5" />
      {meta.label}
    </div>
  );
}

export default function SchedulerKey({ onClose }) {
  return (
    <div className="absolute right-0 top-11 z-40 w-72 rounded-xl border border-slate-200 bg-white p-4 shadow-xl" data-testid="scheduler-key-popover">
      <div className="text-xs font-bold uppercase tracking-wide text-slate-500 mb-2">Shifts</div>
      <div className="grid grid-cols-2 gap-2">
        {SHIFT_STATUS_ORDER.map((k) => <Pill key={k} meta={SHIFT_STATUS_META[k]} />)}
      </div>
      <div className="text-xs font-bold uppercase tracking-wide text-slate-500 mt-4 mb-2">Assets</div>
      <div className="grid grid-cols-2 gap-2">
        {Object.values(ASSET_STATE_META).map((m) => <Pill key={m.label} meta={m} />)}
      </div>
      {onClose && <button onClick={onClose} className="mt-3 w-full text-xs text-slate-400 hover:text-slate-600" data-testid="scheduler-key-close">Close</button>}
    </div>
  );
}
